export const SCROLL_DIRECTION = {
  REVERSE: 'REVERSE',
  FORWARD: 'FORWARD',
};

export const EVENT = {
  START: 'start',
  ENTER: 'enter',
  LEAVE: 'leave',
  END: 'end',
};

export const STATE = {
  BEFORE: 'BEFORE',
  DURING: 'DURING',
};
